import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'unh-students-portfolio',
  templateUrl: './students-portfolio.component.html',
  styleUrls: ['./students-portfolio.component.scss']
})
export class StudentsPortfolioComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
